import React from "react";
import { Container } from "./styled/title";

function Title(props) {
  return <Container {...props} />;
}

export default Title;
